export enum POKER_CURRENCY {
  chips = 'chips',
  gold = 'gold',
  stamps = 'stamps',
  vip_pts = 'vip_pts',
  event_currency = 'event_currency',
  deals = 'deals!',
  club_tier = 'club_tier'
}
